import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { CacheObjectService, DeviceService } from '@app/core';
import { ScrollToLastPosition } from '@app/helper/scroll-to-last-position';
import { IndicatorService } from '@app/shared';
import { filter, map } from 'rxjs/operators';

import { ListItemAudioBookService } from './list-item-audio-book.service';

@Component({
  selector: 'navaar-list-item-audio-book',
  templateUrl: './list-item-audio-book.component.html',
  styleUrls: ['./list-item-audio-book.component.scss']
})
export class ListItemAudioBookComponent extends ScrollToLastPosition implements OnInit {
  public readonly PAGE_SIZE = 12;
  public title: string;
  public identifier: number;
  public books: Array<any> = [];
  public isLoading: boolean = false;
  public isEnd: boolean = false;
  public keyUrl: string;

  public get pageNo(): number {
    return this.cache.pageNumer;
  }
  public set pageNo(v: number) {
    this.cache.pageNumer = v;
  }

  constructor(
    private readonly indicator: IndicatorService,
    private readonly chkd: ChangeDetectorRef,
    public readonly device: DeviceService,
    private readonly listItemAudioBookServiceService: ListItemAudioBookService,
    private readonly cache: CacheObjectService<any>,
    private readonly router: Router,
    private readonly route: ActivatedRoute) {

    super(router);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState)
          this.listItemAudioBookServiceService.isBackFromNewItem = true;
      });
  }
  public ngOnInit() {
    this.title = this.route.snapshot.queryParamMap.get('title');
    this.keyUrl = this.route.snapshot.queryParamMap.get('keyUrl');
    this.identifier = +this.route.snapshot.paramMap.get('id');
    this.books = [];
    this.loadBookNewListNext();
  }
  public goToPage(page: number) {
    this.pageNo = page;
    this.listItemAudioBookServiceService.isBackFromNewItem = false;
    this.loadBookNewListNext();
  }

  public async loadBookNewListNext() {
    let url: string;
    if (this.keyUrl === 'recommend') {
      url = `/api/audiobooks/${this.keyUrl}/${this.identifier}?$inlinecount=allpages&$skip=${this.pageNo * this.PAGE_SIZE}&$top=${this.PAGE_SIZE}`;
    } else
      url = `/${this.keyUrl}?$top=20`;
    this.isLoading = true;
    await this.cache.getObjectCacheOfList(url, `${this.keyUrl}/${this.identifier}`, this.pageNo).pipe(
      map((res) => {
        this.isLoading = false;
        this.isEnd = (res.items.length === res.total);
        this.books = res.items;
        this.indicator.hide();
        this.indicator.hideHude();
        this.chkd.detectChanges();
        return res;
      })
    ).toPromise();
    if (this.listItemAudioBookServiceService.isBackFromNewItem)
      super.scrollToPosition();
  }
}